import { render, staticRenderFns } from "./MessageReadBlock.vue?vue&type=template&id=6fe44942&scoped=true&"
import script from "./MessageReadBlock.vue?vue&type=script&lang=ts&"
export * from "./MessageReadBlock.vue?vue&type=script&lang=ts&"
import style0 from "./MessageReadBlock.vue?vue&type=style&index=0&id=6fe44942&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fe44942",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VFadeTransition } from 'vuetify/lib/components/transitions';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VLayout } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCardText,VFadeTransition,VFlex,VLayout})
